module.exports = __webpack_public_path__ + "static/anchor-logo-50e880d564b1a2dc1c154d6461259eec.svg";